import { WaybillIdView } from '../../../../models';
import { ShipmentWaybillEdit } from '../../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ShipmentWaybillMainInfoEditDialogComponent } from '../../../../../ui-kit';

export class ShipmentWaybillOverviewLoad {
  public static readonly type = '[ShipmentWaybillOverview] Load Overview';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillOverviewEdit {
  public static readonly type = '[ShipmentWaybillOverview] Edit Overview';
  constructor(
    public payload: {
      id: string;
      data: ShipmentWaybillEdit;
      dialogRef: MatDialogRef<ShipmentWaybillMainInfoEditDialogComponent>;
    },
  ) {}
}

export class ShipmentWaybillOverviewLoading {
  public static readonly type = '[ShipmentWaybillOverview] Change load status';
  constructor(public payload: boolean) {}
}

export class ShipmentWaybillOverviewSetInitialState {
  public static readonly type = '[ShipmentWaybillOverview] Set Initial State';
}
